import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { SharedFileRequestStatus } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { WSPosterProps } from "@wingspanhq/fe-component-library";
import { ValidationProgress } from "../../components/ValidationProgress";
import React from "react";
import { getSharedFileIsValidatingActive } from "../helpers/getSharedFileIsValidatingActive";
import { selectorSharedFileExtractedFields } from "../../../../selectors/selectorSharedFileExtractedFields";
import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";

export const payeeSharedFileRenderCardDescription = (
  requirement: IRequirementResponse,
  sharedFile?: ISharedFileRequestResponse
) => {
  const signedDocumentDescriptions: Record<
    SharedFileRequestStatus,
    WSPosterProps
  > = {
    [SharedFileRequestStatus.PendingUpload]: {
      type: "documents",
      title: "File not uploaded",
      description: "Waiting for the contractor to upload a file."
    },
    [SharedFileRequestStatus.PendingSubmission]: {
      type: "documents",
      title: "Validation has failed.",
      description:
        "Contractor has a few attempts to try to upload the file again."
    },
    [SharedFileRequestStatus.Processing]: {
      type: "documents",
      title: "Validation in progress",
      description:
        "The contractor's file is being validated. This may take a few minutes."
    },
    [SharedFileRequestStatus.Failed]: {
      type: "documents",
      title: "File uploading has failed",
      description: "Something went wrong while uploading the file."
    },
    [SharedFileRequestStatus.Complete]: {
      type: "done",
      title: "Your file upload is complete",
      description: "You can download the file below."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: sharedFile?.status || SharedFileRequestStatus.PendingUpload,
    documentStatuses: signedDocumentDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document was uploaded",
      description:
        "The document was uploaded. The requirement now requires approval."
    },
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect the contractor’s eligibility for related engagements."
    },
    approvedStatus: null,
    customContent: getSharedFileIsValidatingActive(sharedFile) ? (
      <ValidationProgress jobs={sharedFile?.jobs} />
    ) : selectorSharedFileExtractedFields(sharedFile) ? (
      <EmptyComponent />
    ) : null
  });
};
